/*导入所有类型*/

import * as types from './type'

export default {
	/*页面刷新，导航默认选中当前页面*/

	changeNav : ( {commit}, sel)=>{

		commit (types.CHANGE_NAV,sel);
		
	}
}


// WEBPACK FOOTER //
// ./src/store/actions.js